export default __webpack_public_path__ + "static/media/favicon.73c4bc67.png";